// NIFTY 50 index + its current constituent stocks.
// NOTE: index membership changes periodically (rebalancing) -- treat this
// as a good-enough default list and re-sync it against NSE's published
// NIFTY 50 constituent list every so often.

export const NIFTY_INDEX = "NIFTY 50";

export const NIFTY50_STOCKS = [
  "RELIANCE", "TCS", "HDFCBANK", "ICICIBANK", "INFY",
  "HINDUNILVR", "ITC", "SBIN", "BHARTIARTL", "KOTAKBANK",
  "LT", "AXISBANK", "BAJFINANCE", "ASIANPAINT", "MARUTI",
  "HCLTECH", "SUNPHARMA", "TITAN", "ULTRACEMCO", "WIPRO",
  "NESTLEIND", "ADANIENT", "ADANIPORTS", "ONGC", "NTPC",
  "POWERGRID", "M&M", "TATAMOTORS", "TATASTEEL", "JSWSTEEL",
  "INDUSINDBK", "BAJAJFINSV", "HDFCLIFE", "SBILIFE", "TECHM",
  "DRREDDY", "CIPLA", "DIVISLAB", "GRASIM", "BRITANNIA",
  "EICHERMOT", "HEROMOTOCO", "BAJAJ-AUTO", "COALINDIA", "BPCL",
  "IOC", "UPL", "SHREECEM", "APOLLOHOSP", "HINDALCO", "TATACONSUM",
];

export const UNDERLYING_OPTIONS = [NIFTY_INDEX, ...NIFTY50_STOCKS];
